import React from 'react';
import './styles.css';
import ScrollToTop from './components/ScrollToTop';
import AppRouter from './AppRouter';

function App() {
  return (
    <>
      <ScrollToTop />
      <AppRouter />
    </>
  );
}

export default App;